import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PromotionItemDiscountStrategy } from '@app/common';
import React from 'react';

const columnHelper = createColumnHelper<{ value: PromotionItemDiscountStrategy, label: string }>();

const columns = [
  columnHelper.display({
    id: 'type',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Type
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.row.original.label}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const PromotionActionTargetSelect = ({ label = 'Cibles de remise', data, ...props }: Omit<SelectProps<any>, 'table'> & { data: any[] }) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => item.value,
        value: (item) => item,
        display: (item) => item.label
      }}
      {...props} />
  );
};
